<template>
    <div class="lms__superadmin_customer_edit_details">
        <form-text
            :name="'customer-name'"
            :label="$t('lms.customer.labels.name')"
            :required="true"
            :v-validate="'required|max:45'"
            :data-vv-as="$t('forms.dataVvAs.name')"
            v-model="customerName"
        />
        <form-textarea
            :name="'customer-notes'"
            :label="$t('lms.customer.labels.notes')"
            :v-validate="'max:5000'"
            :data-vv-as="$t('forms.dataVvAs.notes')"
            v-model="customerNotes"
        />
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import PopNotify from '@/components/default/shared/PopNotify'
import FormTextarea from '@/components/default/forms/FormTextarea'
import FormText from '@/components/default/forms/FormText'
import { validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit } from '@/helpers/mixins'
export default {
  name: 'lms-superadmin-customer-edit-details',
  components: {
    FormText,
    FormTextarea,
    PopNotify
  },
  mixins: [validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit],
  computed: {
    customerName: {
      get () {
        return this.$store.getters.getLmsSuperadminCustomerName
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminCustomerSetName', value)
      }
    },
    customerNotes: {
      get () {
        return this.$store.getters.getLmsSuperadminCustomerNotes
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminCustomerSetNotes', value)
      }
    },
    //
    watchContent () {
      return this.customerName + this.customerNotes
    },
    //
    rootItemName () {
      return 'customer'
    }
  },
  methods: {
    updateCustomerStatus (value) {
      let status = value ? 'active' : 'draft'
      this.$store.dispatch('lmsSuperadminCustomerSetStatus', status)
    }
  },
  inject: ['$validator']
}
</script>
